export { GgzcgV1DiagnosticReportRead as GgzctV1DiagnosticReportRead } from '../../GGZCg/v1/GgzcgV1DiagnosticReportRead';
